import { IHospital } from '@alberta/konexi-shared';
import { ISearchable } from 'src/app/common/contracts/components/searchable';

import { AggregateRoot } from '../aggregate-root';

export class HospitalDto extends AggregateRoot
  implements IHospital, ISearchable {
  _id: string;
  timestamp: Date;
  archived: boolean;
  company: string;
  name: string;
  companyName: string;
  additionalCompanyName: string;
  address: string;
  postalCode: string;
  city: string;
  phone: string;
  fax: string;
  email: string;
  website: string;

  constructor() {
    super();
  }
  get displayText(): string {
    return `${this.companyName} (${this.city})`;
  }
}
